import { CommonModule } from "@angular/common";
import { HttpClientModule } from "@angular/common/http";
import { NgModule } from "@angular/core";
import { FormsModule } from "@angular/forms";
import { NbAlertModule, NbCardModule, NbFormFieldModule, NbInputModule, NbTagModule, NbToggleModule } from "@nebular/theme";
import { AuthService } from "./auth/auth.service";
import { FormBuilderComponent } from "./widgets/form-builder/form-builder/form-builder.component";
import { MessageBoxComponent } from "./widgets/message-box/message-box.component";
import { TagListComponent } from './widgets/tag-list/tag-list.component';
@NgModule({
    declarations: [FormBuilderComponent, MessageBoxComponent, TagListComponent],
    exports: [FormBuilderComponent, MessageBoxComponent],
    imports: [
        HttpClientModule, NbCardModule,
        NbInputModule,
        NbAlertModule,
        NbToggleModule,
        NbTagModule,
        CommonModule, FormsModule, NbFormFieldModule,
    ],
    providers: [AuthService],
})
export class CoreModule { }